<!--
 * @Description: 罐车
-->
<template>
  <el-dialog :visible="visible" width="880px" :close-on-click-modal="false" @close="onClose" @open="onOpen">
    <span slot="title" class="dialog-title">查看详情</span>
    <div v-if="status === 'CZ' || status === 'HZ'" class="dialoginfo">
      <el-form :inline="true" label-width="110px">
        <el-form-item>
          <span slot="label">工程名称：</span>
          <div class="text1" style="width: 280px">
            {{ config.projectName }}
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label">车牌号：</span>
          <div class="text1" style="width: 280px">{{ config.carNo }}</div>
        </el-form-item>
        <el-form-item>
          <span slot="label">浇筑部位：</span>
          <div class="text1" style="width: 280px">
            {{ config.pourPosition }}
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label">标号：</span>
          <div class="text1" style="width: 280px">{{ config.strengthGrade }}</div>
        </el-form-item>
        <el-form-item>
          <span slot="label">票面量(方)：</span>
          <div class="text1" style="width: 280px">{{ config.faceValue }}</div>
        </el-form-item>
        <el-form-item>
          <span slot="label">容重：</span>
          <div class="text1" style="width: 280px">{{ config.unitWeight }}</div>
        </el-form-item>
        <el-form-item>
          <span slot="label">毛重：</span>
          <div class="text1" style="width: 280px">{{ config.grossWeight }}</div>
        </el-form-item>
        <el-form-item>
          <span slot="label">皮重：</span>
          <div class="text1" style="width: 280px">{{ config.tareWeight }}</div>
        </el-form-item>
        <el-form-item>
          <span slot="label">净重：</span>
          <div class="text1" style="width: 280px">{{ config.netWeight }}</div>
        </el-form-item>
        <el-form-item>
          <span slot="label">方量：</span>
          <div class="text1" style="width: 280px">
            {{ config.productionVolume }}
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label">误差量：</span>
          <div class="text1" style="width: 280px">{{ config.residueNum }}</div>
        </el-form-item>
        <el-form-item>
          <span slot="label">过磅时间：</span>
          <div class="text1" style="width: 280px">{{ config.weightTime }}</div>
        </el-form-item>
      </el-form>
    </div>
    <div v-else class="dialoginfo">
      <el-form :inline="true" label-width="110px">
        <el-form-item>
          <span slot="label">所属单位：</span>
          <div class="text1" style="width: 280px">{{ config.company }}</div>
        </el-form-item>
        <el-form-item>
          <span slot="label">车牌号：</span>
          <div class="text1" style="width: 280px">{{ config.carNo }}</div>
        </el-form-item>
        <el-form-item>
          <span slot="label">本次皮重：</span>
          <div class="text1" style="width: 280px">
            {{ config.currentTareWeight }}
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      指定打印模板：
      <el-select v-model="printIndex">
        <el-option v-for="(item, index) in printTemplateList" :key="index" :value="item.templateId" :label="item.templateName"></el-option>
      </el-select>
      <span>
        <el-button class="bottom_all" :disabled="isPrint" @click.stop="print()">打 印</el-button>
      </span>
      <span>
        <el-button class="bottom_all_two" style="margin-left: 24px" @click.stop="onClose">关 闭 </el-button>
      </span>
    </span>

    <Printer v-if="visible" ref="raw-printer" :secondKey="secondKey" :data="config" :userName="userInfo.userRealName" :userSelectIndex="printIndex" type="guanche" @confList="getPrintTemplate" @closeDialog="closeDialog"></Printer>
  </el-dialog>
</template>

<script>
import Printer from "@/views/components/Printer.vue";
import { getUserInfo } from "@/utils/auth";
export default {
  components: { Printer },
  data() {
    return {
      printIndex: "",
      secondKey: "",
      userInfo: "",
      isPrint: false,
    };
  },
  props: {
    config: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
    stationId: {
      type: String,
      default: "",
    },
    status: {
      type: String,
    },
    printTemplateList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    config(val) {
      if (val) {
        this.config = val;
      }
    },
    printTemplateList(val) {
      if (val) {
        this.getPrintTemplate(val);
      }
    },
  },
  async mounted() {
    this.userInfo = await getUserInfo();
  },
  methods: {
    onOpen() {
      console.log(this.config);
      this.config.receiveNum = this.config.receiveNum || 0;
      switch (this.status) {
        case "CZ":
          this.secondKey = "TankerOut";
          break;

        case "HZ":
          this.secondKey = "TankerIn";
          break;

        case "PZ":
          this.secondKey = "tankerTare";
          break;

        default:
          break;
      }
    },
    onClose() {
      this.$emit("update:visible", false);
    },
    closeDialog() {
      this.isPrint = false;
    },
    print() {
      // this.$emit("print", this.config);
      //console.log(this.config);
      this.isPrint = true;
      //过磅时间
      // this.$set(this.config, "weightTime2", new Date(this.config.weightTime).Format("yyyy-MM-dd"));
      // let config = JSON.parse(JSON.stringify(this.config));
      // if (this.status === "PZ") {
      //   updateTemplateIdTare({
      //     id: this.config.id,
      //     templateId: this.printIndex,
      //   }).then(res => {
      //     if (res.code === 1001) {
      //       this.$emit("gettable3");
      //       console.log(id);
      //       // if (id) {
      //       //   updateConcreteCounterfoil({ id: config.id, operateType: 1 });
      //       // }
      //     }
      //   });
      // } else {
      //   updateTemplateId({
      //     id: config.logisticsCode,
      //     templateId: this.printIndex,
      //   }).then(res => {
      //     if (res.code === 1001) {
      //       this.$emit("gettable3");
      //       if (id) {
      //         updateConcreteCounterfoil({
      //           id: config.logisticsCode,
      //           operateType: 1,
      //         });
      //       }
      //     }
      //   });
      // }
      setTimeout(() => {
        this.$refs["raw-printer"].print();
      }, 200);
    },
    getPrintTemplate() {
      let list = this.printTemplateList;
      //整理conditionList和模板id
      let conditionDes = [];
      if (!list) return;
      list.forEach(item => {
        let conditionObj = {};
        conditionObj.stationTemplateId = item.stationTemplateId;
        item.conditionList?.forEach(ite => {
          conditionObj[ite.conditionName] = ite.conditionData;
        });
        conditionDes.push(conditionObj);
      });
      //对比conditionDes和this.config
      let checkSame = condition => {
        let a = condition.find(item => {
          //不考虑["stationTemplateId","brand","originPlace","transportUnit"]这些属性是否相同
          let a = Object.keys(item).filter(item => !["stationTemplateId", "brand", "originPlace", "transportUnit"].find(ite => item == ite));
          //判断剩下的属性值是否和low的相同
          let sameLength = 0;
          a.forEach(ite => {
            if (ite == "isFirstSupply") {
              let isFirstSupply = this.config[ite] == 1 ? "Y" : "N";
              if (item[ite] === isFirstSupply) {
                sameLength++;
              }
            } else {
              if (item[ite] === this.config[ite]) {
                sameLength++;
              }
            }
          });
          //找出low和condition属性全部相同的哪个对象并返回id
          return sameLength == a.length;
        });
        if (a == undefined) {
          return 0;
        }
        return a.stationTemplateId;
      };
      if (this.config.templateId) {
        this.printIndex = this.config.templateId;
      } else {
        if (checkSame(conditionDes) != 0) {
          let marryTemplate = this.printTemplateList.find(item => item.stationTemplateId == checkSame(conditionDes));
          this.printIndex = marryTemplate.templateId;
        } else {
          this.printIndex = this.printTemplateList[0].templateId;
        }
      }
    },
  },
};
</script>
<style lang="scss">
.receiveNum {
  .el-input__inner {
    width: 133px;
    height: 133px;
  }
}
</style>
